import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import {
    displayModalCreateDocumento,
    updateInputs,
    createOrUpdateDocumento,
    previewDocumento
} from '../../actions/contratoanual'

class ModalCreateDocumento extends Component {

	handleCloseModal = (e) => {

		const modal = document.getElementById('modalCreateDocumento')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreateDocumento .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreateDocumento(false, '', ''), 300)
    }

	render() {
        
        const { modalCreateDocumento, enums, docs_vigentes } = this.props


        const readOnly = (docs_vigentes.count() > 0)

		if (!modalCreateDocumento.get('show')) {
			return null
        }
                        

		return(
			<Modal id="modalCreateDocumento" show={ true } ZIndex={ 2000 } >

                <form id="form" noValidate>

					<ModalHeader title={ modalCreateDocumento.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
                     

					<ModalButtonStrip>   
                        <BoxButton name="eye" onClick={e => {e.preventDefault(); this.props.previewDocumento(modalCreateDocumento.getIn(['data', 'id']))}} disabled={ modalCreateDocumento.get('btnDisabled') } title=" Visualizar el documento antes de enviar a aprobación del proveedor" />                      
                        <BoxButton name="floppy-o" disabled={ modalCreateDocumento.get('btnDisabled') } title="Guardar y enviar al proveedor" onClick={ e => { e.preventDefault(); this.props.createOrUpdateDocumento() }} />
					</ModalButtonStrip>

					<ModalBody >
						<div style={{ width: '80vw', height: '70vh' }}>
                            <div className="row">
                                <div className="col-md-4">
                                    <table className="table table-condensed table-bordered table-striped nowrap">
                                        <colgroup>
                                            <col style={{ width:'35%', color: '#333', fontWeight: 'bold' }} />
                                            <col style={{}}/>
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <td>Tipo de documento</td>
                                                <td>{ modalCreateDocumento.getIn(['data', 'tipo']) ? enums.documentos.tipos[modalCreateDocumento.getIn(['data', 'tipo'])].NOMBRE : 'PENDIENTE' }</td>
                                            </tr>
                                            <tr>
                                                <td>Número documento</td>
                                                <td>{ (modalCreateDocumento.getIn(['data', 'tipo']) ? enums.documentos.tipos[modalCreateDocumento.getIn(['data', 'tipo'])].PREFIJO : 'PENDIENTE') + (modalCreateDocumento.getIn(['data', 'consecutivo']) || '') }</td>
                                            </tr>
                                            <tr>
                                                <td>Proveedor</td>
                                                <td>{ modalCreateDocumento.getIn(['data', 'proveedore', 'nombre']) }</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Seleccione el tipo de documento</label>
                                                <select className="form-control input-sm" value={ modalCreateDocumento.getIn(['data', 'tipo']) || 0 } onChange={ (e) => { this.props.updateInputs(`modalCreateDocumento.data.tipo`, e.target.value) } } disabled >
                                                    <option value={ 0 } disabled>Seleccione una opcion</option>
                                                    {
                                                        Object.keys(enums.documentos.tipos).map(a => {
                                                            return (
                                                                <option key={ `opt1[${a}]` } value={ a }>{ enums.documentos.tipos[a].NOMBRE }</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Inicio del contrato</label>
                                                <input type="date" className="form-control input-sm" value={ moment(modalCreateDocumento.getIn(['data', 'fecha_inicio'])).format('YYYY-MM-DD') || '' } onChange={ (e) => this.props.updateInputs(`modalCreateDocumento.data.fecha_inicio`, e.target.value) } disabled={ readOnly } />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Terminación del contrato</label>
                                                <input type="date" className="form-control input-sm" value={ moment(modalCreateDocumento.getIn(['data', 'fecha_entrega'])).format('YYYY-MM-DD') || '' } disabled />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">Seleccione la plantilla del documento</label>
                                                <select className="form-control input-sm" value={ modalCreateDocumento.getIn(['data', 'plantilla_id']) || 0 } onChange={ (e) => { this.props.updateInputs(`modalCreateDocumento.data.plantilla_id`, e.target.value) } } disabled={ readOnly }>
                                                    <option value={ 0 } disabled>Seleccione una opcion</option>
                                                    {
                                                        modalCreateDocumento.get('plantillas').filter(a => a.get('tipo') === Number(modalCreateDocumento.getIn(['data', 'tipo']))).map(a => {
                                                            return (
                                                                <option key={ `opt1[${a.get('id')}]` } value={ a.get('id') }>{ a.get('nombre') }</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>      

                                    {
                                        modalCreateDocumento.getIn(['data','aprobacion', 'observaciones']) && (
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="control-label">Observaciones del proveedor</label>
                                                        <textarea type="text" className="form-control input-sm" rows={4} defaultValue={ modalCreateDocumento.getIn(['data', 'aprobacion', 'observaciones']) || '' } disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreateDocumento: state.contratoanual.get('modalCreateDocumento'),
        enums: state.common.get('enums').toJS(),
        docs_vigentes: state.contratoanual.getIn(['solicitud', 'documentos']).filter(x => x.get('estado') == 12)
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreateDocumento: (show, title, mode) => dispatch(displayModalCreateDocumento(show, title, mode)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        createOrUpdateDocumento: () => dispatch(createOrUpdateDocumento()),
        previewDocumento: (id) => dispatch(previewDocumento(id))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateDocumento)



// WEBPACK FOOTER //
// ./src/components/ContratoAnual/ModalCreateDocumento.jsx